// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"624":"38f662c2","2461":"38f662c2","4908":"6a39a819","4930":"9e4bbf87"}[chunkId] + ".chunk.css";
};